import React from 'react';
import { NavLink  } from "react-router-dom";

export default class HeaderLink extends React.Component {
  render(){
    return (
      <div className='header-link'>
        <NavLink
          exact
          onClick={this.props.onClick}
          activeClassName="selected"
          to={this.props.target.path}
          data-translation={"header."+this.props.translationTag}
        >
          {this.props.target.desc}
        </NavLink >
      </div>
    );
  }
}
